const works = [
  {
    name: 'UFL Game',
    link: 'https://www.uflgame.com/',
    image: 'images/ufl.webp'
  },
  {
    name: 'Nascent Design',
    link: 'https://nascentdesign.com/',
    image: 'images/nascentdesign.webp'
  },
  {
    name: 'Boom & Bloom',
    link: 'https://www.boomandbloom.com/',
    image: 'images/boomandbloom.webp'
  },
  {
    name: 'Studiogusto.com',
    link: 'https://studiogusto.com',
    image: 'images/studiogusto.webp'
  },
  {
    name: 'Seacat - Rossinavi',
    link: 'https://seacat.rossinavi.it',
    image: 'images/seacat.webp'
  },
  {
    name: 'Blue - Rossinavi',
    link: 'https://blue.rossinavi.it',
    image: 'images/blue.webp'
  },
  {
    name: 'Peptone',
    link: 'https://peptone.io',
    image: 'images/peptone.webp'
  },
  /* {
    name: 'Beauty Sphere',
    link: 'https://beautysphere.com',
    image: 'images/beautysphere.webp'
  }, */
  {
    name: 'Ghost Unicorns',
    link: 'https://www.ghostunicorns.com',
    image: 'images/ghostunicorns.webp'
  },
  /* {
    name: 'Sterling',
    link: 'https://www.sterling.it/en',
    image: 'images/sterling.webp'
  }, */
  /* {
    name: 'Asics - Mindup Lifter',
    link: 'https://minduplifter.asics.com',
    image: 'images/asics.webp'
  }, */
 /*  {
    name: 'Coca Cola - Game <em>(view it on mobile)</em>',
    link: 'http://cocacola.wearetesting.it',
    image: 'images/cocacola.webp'
  }, */
  /* {
    name: 'Oneiric - Rossinavi',
    link: 'https://oneiric.rossinavi.it',
    image: 'images/oneiric.webp'
  }, */
  /* {
    name: 'Sgrappa',
    link: 'https://www.sgrappa.com',
    image: 'images/sgrappa.webp'
  }, */
  /* {
    name: 'Marison Ray',
    link: 'https://www.marisonray.com',
    image: 'images/marisonray.webp'
  }, */
  /* {
    name: 'Henge',
    link: 'https://www.henge07.com',
    image: 'images/henge.webp'
  }, */
  /* {
    name: 'Turn',
    link: 'https://www.turnhr.tech',
    image: 'images/turn.webp',
  }, */
  /* {
    name: 'Play 2',
    link: 'https://play2.studiogusto.com',
    image: 'images/play2.webp',
  }, */
  /* {
    name: 'Fabrizio Milesi',
    link: 'https://fabriziomilesi.com',
    image: 'images/fabriziomilesi.webp',
  },
  {
    name: 'Platek',
    link: 'https://www.platek.eu',
    image: 'images/platek.webp',
  }, */
]

export default works
